import styled from 'styled-components';
import { cover } from '../../utils/styles';

export const StyledChip = styled.h6`
  display: inline-block;
  position: relative;
  overflow: hidden;
  border-radius: var(--border-radius-small);
  margin: 0 var(--size-space-tiny);
  padding: 0;
  font-weight: var(--font-weight-medium);
  line-height: 1em;
  > * {
    position: relative;
    z-index: 5;
    display: block;
    width: 100%;
    height: 100%;
    padding: var(--size-space-tiny) var(--size-space-tiny);
    margin: 0;
    background-color: var(--color-primary-dark);
    color: var(--color-primary-light);
  }
  &::after {
    ${cover};
    content: '';
    position: absolute;
    z-index: 0;
    background-color: var(--color-level-0);
  }
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;
